// src/i18n.js

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Örnek dil dosyaları
import tr from './locales/tr/translation.json'
import en from './locales/en/translation.json'
import de from './locales/de/translation.json'
import fr from './locales/fr/translation.json'
import el from './locales/el/translation.json'
import nl from './locales/nl/translation.json'

i18n.use(initReactI18next).init({
  resources: {
    tr: {
      translation: tr,
    },
    en: {
      translation: en,
    },
    de: {
      translation: de,
    },
    fr: {
      translation: fr,
    },
    el: {
      translation: el,
    },
    nl: {
      translation: nl,
    },
  },
  lng: 'tr', // Varsayılan dil
  fallbackLng: 'en', // Bir çeviri bulunmazsa geri düşülecek dil
  interpolation: {
    escapeValue: false, // React zaten XSS koruması sağlıyor
  },
})

export default i18n